<template>
  <v-container>
    <v-col>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-col cols="12">
          <v-text-field
            label="ID плейлиста"
            v-model="playlist.list_id"
            :rules="notEmptyRules.concat([embedPlayer !== null || 'не верный id'])"
            name="list_id"
            @input="checkId"
            required
          ></v-text-field>
          <div class="text-center" v-show="embedPlayer" v-html="embedPlayer"></div>
          <input type="text" hidden name="site_key" :value="$attrs.site_key" />
        </v-col>
        <v-col cols="12">
          <v-text-field
            v-model="playlist.title"
            name="title"
            :counter="100"
            label="Заголовок"
            required
            :rules="notEmptyRules"
          ></v-text-field>
        </v-col>
        <v-col cols="12">
          <v-textarea
            v-model="playlist.description"
            name="description"
            :counter="100"
            label="Описание"
          ></v-textarea>
        </v-col>
        <v-col cols="12" class="text-xs-center">
          <FileInput
            label="Обложка"
            :url="playlist.cover.url"
            @file-selected="imageSelected"
          ></FileInput>
        </v-col>
        <v-switch color="green" v-model="playlist.published" label="Опубликован"></v-switch>
        <v-row row justify-beetwen-space>
          <v-col lg6 class="text-lg-center">
            <v-btn color="success" @click="submit">Сохранить</v-btn>
          </v-col>
          <v-col v-if="isEdit" lg6 class="text-lg-center">
            <v-btn color="error" @click="deleteDialog = true">Удалить</v-btn>
          </v-col>
        </v-row>
      </v-form>
    </v-col>
    <DeleteDialog
      v-if="isEdit"
      :title="playlist.title"
      :active="deleteDialog"
      @remove="deletePlaylist"
      @cancel="deleteDialog = false"
    >
    </DeleteDialog>
  </v-container>
</template>

<script>
import DeleteDialog from '@/components/DeleteDialog'

import api from '@/mixins/api'
import FileInput from '@/components/FileInput'

export default {
  name: 'playlist_create_edit',
  components: { FileInput, DeleteDialog },
  mixins: [api],
  data() {
    return {
      deleteDialog: false,
      valid: false,
      playlist: {
        id: 3,
        list_id: '',
        published: false,
        title: '',
        description: '',
        cover: { url: '' },
        image: '',
        info: {},
      },
    }
  },
  computed: {
    embedPlayer() {
      const info = this.playlist.info
      if (info && info.items && info.items.length > 0) {
        return info.items[0].player.embedHtml.replace('http://', 'https://')
      }
      return null
    },
    isEdit() {
      return this.$route.name === 'playlist_edit' && this.$route.params.id > 0
    },
  },
  created() {
    if (this.isEdit) {
      this.getPlaylist()
    }
  },
  methods: {
    getPlaylist() {
      this.axios({
        url: `/v1/media/playlist/${this.$route.params.id}`,
        method: 'get',
      })
        .then((res) => {
          this.playlist = res.data
        })
        .catch((err) => {
          this.$emit('showSnakBar', err.response.data)
        })
    },
    submit() {
      if (this.isEdit) {
        return this.updatePlaylist()
      } else {
        return this.savePlaylist()
      }
    },
    imageSelected(e) {
      this.image = e
      this.playlist.cover.url = e.url
    },
    deletePlaylist() {
      if (!this.isEdit) {
        return
      }
      this.axios({
        url: `/v1/media/playlist/${this.$route.params.id}`,
        method: 'delete',
      })
        .then(() => {
          this.showSnackbar('Удалено', 'green')
          this.$router.push({ name: 'playlist' })
        })
        .catch((err) => {
          this.$log.error(err.response ? err.response.data : err)
          this.showSnackbar(err.response ? err.response.data : err, 'error')
        })
    },
    updatePlaylist() {
      this.axios({
        url: `/v1/media/playlist/${this.$route.params.id}`,
        method: 'post',
        data: this.playlist,
      })
        .then((resp) => {
          this.article = resp.data
          this.tags = this.article.tags || []
          this.showSnackbar('Сохранено', 'green')
        })
        .catch((err) => {
          this.$log.error(err.response ? err.response.data : err)
          this.showSnackbar(err.response ? err.response.data : err, 'error')
        })
    },
    savePlaylist() {
      if (!this.$refs.form.validate()) {
        this.$log.debug('form', this.$refs.form)
        this.showSnackbar('Заполните все поля', 'error')
        return
      }
      const form = this.$refs.form.$el
      const data = new FormData(form)
      this.axios({
        url: `/v1/media/playlist`,
        method: 'post',
        data: data,
      })
        .then((resp) => {
          this.article = resp.data
          this.tags = this.article.tags || []
          this.showSnackbar('Сохранено', 'green')
          this.$router.push({ name: 'playlist_edit', params: { id: resp.data.id } })
        })
        .catch((err) => {
          this.$log.error(err.response ? err.response.data : err)
          this.showSnackbar(err.response ? err.response.data : err, 'error')
        })
    },
    checkId() {
      if (!this.playlist.list_id || this.playlist.list_id.length < 11) {
        return
      }
      this.axios({
        url: `/v1/media/playlist/${this.playlist.list_id}/info`,
        method: 'get',
      }).then((res) => {
        this.$log.debug(res)
        const info = res.data
        if (info.items && info.items.length < 1) {
          // this.$refs.form.valid = false
          return
        }
        this.playlist.info = info
      })
    },
  },
}
</script>
